const settingsStorage = JSON.parse(localStorage.getItem('settings'));

let url;

// Production follows the config.json URL, configured on App.js
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  url = process.env.REACT_APP_DOMAIN ?? '';
} else {
  url = settingsStorage?.apiUrl ?? '';
}

export const APP_VERSION = '2.0.0';
export const BASE_URL = url;
export const API_BASE_URL = `${BASE_URL}/api`;
export const DEBUG_BASE_URL = `${BASE_URL}/apm`;
export const SIGNALR_BASE_URL = `/SignalR`;
export const ENABLE_REDUX_LOGGER = false;

export const MODULE = {
  servicos: { location: '/servicos', name: 'Serviços', type: 'cigam' },
  industria: { location: '/industria', name: 'Indústria', type: 'cigam' },
  cliente: { location: '/cliente', name: 'Cliente', type: 'cliente' },
};

export default {};
